import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
import { arrowBack } from '../../utilities/icons';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInOrganisationSettings extends AllInOrganisationConsumer(LitElement) {
    static properties = {
        currentOrg: { type: String, reflect: true },
        panel: { type: String, reflect: true },
        name: { type: String },
        _users: { state: true, type: Array },
        _panels: { state: true, type: Array },
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventManager.initHistory({ panel: this.panel ?? '' });
        this.panels.forEach((item) => {
            this[`_show${item.name}`] = (e) => { e.preventDefault(); this._showPanel(item.name); };
        });
        if (this.panel) {
            this._showPanel(this.panel);
        }
        /* if(this.switchto&&this.currentOrg){
            this.panel = this.switchto;
            this._showPanel(this.panel);
            this.switchto = '';
        } */
        //this.renderRoot.querySelector('button,a')?.focus();
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    updated(changedProperties) {
        cardLinks(this.shadowRoot);
    }
    render() {
        let main = '';
        let button = html `<button class="back" @click=${this._hidePanel}><span aria-hidden="true">${arrowBack}</span>N\u00F4l i osodiadau cyfrif y sefydliad</button>`;
        if (this.panel == 'account') {
            main = html `\n            ${button}\n            <allin-organisation-account-form\n                organisation=${this.currentOrg}\n            ></allin-organisation-account-form>\n            `;
        }
        else if (this.panel == 'staff') {
            main = html `\n            ${button}\n            <allin-organisation-user-form\n                organisation=${this.currentOrg}\n            ></allin-organisation-user-form>\n            `;
        }
        else if (this.panel == 'dsa') {
            main = html `\n            ${button}\n            <allin-remote-content get="${this.restUrl}?action=dsa" nonce="${this.nonce}"></allin-remote-content>\n            `;
        }
        else if (this.panel == 'logs') {
            main = html `\n            ${button}\n            <h2>Coming soon</h2>\n            <p>Activity logs will be available soon</p>\n            `;
        }
        else {
            main = html `\n                \n                <div class="grid grid_50">\n                    ${this.panels.map((item) => {
                return html `\n                        <div class="bg inner-padding card">\n                            <h3>${item.text}</h3>\n                            <p>${item.description}</p>\n                            <a href="javascript:void(0)" class="card_target" @click=${this[`_show${item.name}`]}>${item.button}</a>\n                        </div>\n                        `;
            })}\n                </div>\n            `;
        }
        return html `${cache(main)}`;
    }
    _handleContextUpdate(value) {
        this.organisationData = value;
        ({ currentOrg: this.currentOrg, name: this.name, panel: this.panel, view: this.view, restUrl: this.restUrl, nonce: this.nonce } = this.organisationData);
        if (this.panel) {
            this._showPanel(this.panel);
        }
    }
    _showPanel(panel) {
        if (panel == this.panel)
            return;
        this.panel = panel;
        let panelDetails = this.panels.find((item) => { return item.name == panel; });
        let url = panelDetails ? `/${panelDetails.name}-settings` : '';
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name} Dangosfwrdd` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/settings/`, title: `Gosodiadau` },
            panel: { url: `/organisation-dashboard/${this.currentOrg}/settings${url}`, title: panelDetails?.text ?? '' }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'setting', panel: this.panel });
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/settings/' + panelDetails?.name, { panel: this.panel });
    }
    _hidePanel() {
        this.panel = '';
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name} Dangosfwrdd` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/settings/`, title: `Gosodiadau` }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/settings', { panel: '' });
    }
    static styles = [
        accessibility,
        formStyles,
        grid,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }


        h3,p{
            margin:0;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }
        form+form{
            margin-top:2rem;
        }
        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        `
    ];
}
